import { atom } from 'jotai'

export const modalTriggererAtom = atom<'appointmentSelect' | 'back' | undefined>(undefined)

export const selectedAppointmentIdAtom = atom<number | undefined>(undefined)

export const selectedPractitionerIdAtom = atom<number | undefined>(undefined)
